// Formatting shared by the Finance page and its Net Worth tab.

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

// Account balance — keeps the sign (an overdrawn account must read as negative).
export function fmtBal(n) {
  if (!Number.isFinite(n)) return '—';
  return (n < 0 ? '−' : '') + '$' + Math.round(Math.abs(n)).toLocaleString();
}

// Same, to the cent — holdings and investment activity carry amounts under $1.
export function fmtCents(n) {
  if (!Number.isFinite(n)) return '—';
  return (n < 0 ? '−' : '') + '$' + Math.abs(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// 'YYYY-MM-DD' → "Oct 1, 2026" (string-safe — no new Date()). A SharePoint
// dateOnly value ('2026-10-01T07:00:00Z', site-timezone midnight) works too:
// only the date part is read, so nothing is converted through UTC.
export function fmtDay(yyyymmdd) {
  const [y, m, d] = yyyymmdd.slice(0, 10).split('-');
  return `${MONTHS[parseInt(m, 10) - 1]} ${parseInt(d, 10)}, ${y}`;
}

// "Oct 1" — for tables where the year is already on screen.
export function fmtDayShort(yyyymmdd) {
  const [, m, d] = yyyymmdd.slice(0, 10).split('-');
  return `${MONTHS[parseInt(m, 10) - 1]} ${parseInt(d, 10)}`;
}

const WEEKDAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

// "Thu Oct 15" — the weekday is read in UTC from the bare date, so the local
// timezone never moves it.
export function fmtWeekdayShort(yyyymmdd) {
  const [y, m, d] = yyyymmdd.slice(0, 10).split('-').map(Number);
  return `${WEEKDAYS[new Date(Date.UTC(y, m - 1, d)).getUTCDay()]} ${fmtDayShort(yyyymmdd)}`;
}

// A SharePoint instant ('2026-10-16T10:30:50Z') → "5:30 AM", Central time.
export function fmtClockCT(iso) {
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return '';
  return t.toLocaleTimeString('en-US', { timeZone: 'America/Chicago', hour: 'numeric', minute: '2-digit' });
}
